import React from 'react'
import type { TextPair } from './landingContent'

type UseCasesSectionProps = {
  title: string
  items: TextPair[]
}

export const UseCasesSection: React.FC<UseCasesSectionProps> = ({ title, items }) => {
  return (
    <section id="use-cases" className="landing-section">
      <div className="container stack-lg">
        <div className="landing-section-heading"><h2>{title}</h2></div>
        <div className="landing-card-grid">
          {items.map(([cardTitle, body]) => (
            <article key={cardTitle} className="panel landing-info-card">
              <h3>{cardTitle}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
